import React, { useContext, useEffect, useState } from "react";
import "./ClientPanels.css";
import moveTeamImg from "../../../../assets/moveTeamImg";
import accountSvg from "../../../../assets/accountSvg";
import GeneratePreApprovalButton from "../GeneratePreApproval/GeneratePreApprovalButton";
import UnderContractButton from "../UnderContractModal/UnderContractButton";
import pencilSvg from "../../../../assets/pencilSvg";
import EditNotesModal from "../ClientModals/EditNoteModal";

import { AppContext } from "../../../../AppContext";
import { EditNoteContext } from "./EditNoteContext";

const PreApprovalPanel = ({
  index,
  clientName,
  loanOfficerName,
  loanOfficerEmail,
  loanOfficerPhone,
  preApprovalAmt,
  preApprovalDate,
  agentPartner,
  agentEmail,
  agentPhone,
  coAgentPhone,
  downpaymentPercentage,
  downpaymentDollar,
  loanProgram,
  googleTemplateID,
  googleFolderId,
  preApprovalNames,
  loNotes,
  agentNotes,
  id,
  coAgentName,
  loanOfficerTextNotifications,
  agentTextNotifications,
  coAgentTextNotifications,
}) => {
  const {
    userType,
    preApprovalPanelsController,
    setPreApprovalPanelsController,
    userName,
  } = useContext(AppContext);

  const [panelAdd, setPanelAdd] = useState("hidden");
  const [noteEdit, setNoteEdit] = useState("hidden");
  const [notes, setNotes] = useState(
    userType == "Loan Officer" ? loNotes : agentNotes
  );

  useEffect(() => {
    setPanelAdd(
      preApprovalPanelsController[index] == true ||
        preApprovalPanelsController[index] == undefined
        ? "hidden"
        : ""
    );
  }, [preApprovalPanelsController]);

  const currencyFormatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 0,
  });

  const preApprovalTbd = preApprovalAmt ? preApprovalAmt : "TBD";
  const preApprovalAmtFormatted =
    preApprovalTbd > 0
      ? currencyFormatter.format(preApprovalTbd)
      : preApprovalTbd;

  function formatCurrency(number) {
    const formattedNumber = number.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return `$${formattedNumber}`;
  }

  let loanOfficerNote = [];
  let agentNote = [];

  const userIsLo =
    userType === "Loan Officer" && loanOfficerName.includes(userName);
  const userIsAgent = userType === "Agent" && agentPartner.includes(userName);

  loanOfficerNote = (
    <>
      {loNotes ? (
        <>
          <div
            className={`chatMessage ${userIsLo ? "blueChat" : null}`}
            onClick={(e) => {
              if (userIsLo) {
                e.stopPropagation();
                noteEdit === "hidden" ? setNoteEdit("") : setNoteEdit("hidden");
              }
            }}
          >
            <div className="chatMessageNotes">{loNotes}</div>
            {userIsLo ? (
              <div className={`pencil-circle ${userType}`}>{pencilSvg}</div>
            ) : null}
          </div>
        </>
      ) : (
        <>
          {userIsLo ? (
            <div
              className="button addNotes"
              onClick={(e) => {
                e.stopPropagation();
                noteEdit === "hidden" ? setNoteEdit("") : setNoteEdit("hidden");
              }}
            >
              Add Notes
              <div className={`pencil-circle ${userType}`}>{pencilSvg}</div>
            </div>
          ) : (
            <div className="chatName">
              No notes. Check in with {loanOfficerName} for updates.
            </div>
          )}
        </>
      )}
    </>
  );

  agentNote = (
    <>
      {agentNotes ? (
        <>
          <div
            className={`chatMessage ${userIsAgent ? "blueChat" : null}`}
            onClick={(e) => {
              if (userIsAgent) {
                e.stopPropagation();
                noteEdit === "hidden" ? setNoteEdit("") : setNoteEdit("hidden");
              }
            }}
          >
            <div className="chatMessageNotes">{agentNotes}</div>
            {userIsAgent ? (
              <div className={`pencil-circle ${userType}`}>{pencilSvg}</div>
            ) : null}
          </div>
        </>
      ) : (
        <>
          {userIsAgent ? (
            <div
              className="button addNotes"
              onClick={(e) => {
                e.stopPropagation();
                noteEdit === "hidden" ? setNoteEdit("") : setNoteEdit("hidden");
              }}
            >
              Add Notes
              <div className={`pencil-circle ${userType}`}>{pencilSvg}</div>
            </div>
          ) : (
            <div className="chatName">
              No notes. Check in with{" "}
              {coAgentName ? `${agentPartner} & ${coAgentName}` : agentPartner}{" "}
              for updates.
            </div>
          )}
        </>
      )}
    </>
  );

  return (
    <div
      className={
        preApprovalAmtFormatted === "TBD" ||
        (downpaymentPercentage === null && downpaymentDollar === null)
          ? "clientPanel hover slightOpacity"
          : "clientPanel hover"
      }
    >
      <EditNoteContext.Provider
        value={{
          noteEdit,
          setNoteEdit,
          notes,
          setNotes,
          userType,
          id,
          loanOfficerName,
          agentPartner,
          clientName,
          loanOfficerEmail,
          agentEmail,
          coAgentName,
          loanOfficerPhone,
          agentPhone,
          coAgentPhone,
          loanOfficerTextNotifications,
          agentTextNotifications,
          coAgentTextNotifications,
        }}
      >
        <div
          className={`container ${panelAdd}`}
          onClick={(e) => {
            panelAdd === "hidden" ? setPanelAdd("") : setPanelAdd("hidden");
            let arrayOfPanels = [];
            for (
              let i = 0;
              i < document.getElementsByClassName("clientPanel").length;
              i++
            ) {
              if (
                preApprovalPanelsController[index] != undefined
                  ? preApprovalPanelsController[index] && i == index
                  : i == index
              ) {
                arrayOfPanels.push(false);
              } else {
                arrayOfPanels.push(true);
              }
            }
            setPreApprovalPanelsController(arrayOfPanels);
          }}
        >
          <span className="clientName">{clientName}</span>
          <div className={`contactsSection ${panelAdd}`}>
            <div className="contact">
              {moveTeamImg}
              <span className="contactText">{loanOfficerName}</span>
            </div>
            <div className={`pendingPanelAdd ${panelAdd}`}>
              {loanOfficerNote}
            </div>
            <div className="contact">
              {accountSvg}
              <span className="contactText">
                {coAgentName
                  ? `${agentPartner} & ${coAgentName}`
                  : agentPartner}
              </span>
            </div>
            <div className={`pendingPanelAdd ${panelAdd}`}>{agentNote}</div>
          </div>
          <div className={`containerRight ${panelAdd}`}>
            {preApprovalAmtFormatted === "TBD" ? null : (
              <span className={`max ${panelAdd === "hidden" ? "" : "hidden"}`}>
                MAX
              </span>
            )}
            <span className="preApprovedAmount">
              {preApprovalAmtFormatted === "TBD"
                ? "Pending"
                : preApprovalAmtFormatted}
            </span>
            {preApprovalAmtFormatted === "TBD" ? null : (
              <span
                className={`preApprovedDate ${
                  panelAdd === "hidden" ? "" : "hidden"
                }`}
              >
                As of {preApprovalDate}
              </span>
            )}
          </div>
          <div className={`add ${panelAdd}`}>
            <div className="blankRow fivePx"></div>
            <div className="ucInfo-bar-holder">
              <hr className="ucInfo-bar"></hr>
            </div>
            {preApprovalAmtFormatted === "TBD" ? (
              <div>
                Client is Pre-Approved but the Pre-Approved amount has not been
                set in Matrix. Please check in with {loanOfficerName}.
                <div className="blankRow fivePx"></div>
              </div>
            ) : (
              <div className="addTextPanel">
                <div className="addText">
                  <span>Program:</span>
                  <span className="textRight">
                    <b>{loanProgram}</b>
                  </span>
                </div>
                <div className="addText">
                  <span>Max Approval:</span>
                  <span className="textRight">
                    <b>{preApprovalAmtFormatted}</b>
                  </span>
                </div>
                <div className="addText">
                  <span>Downpayment:</span>
                  {downpaymentPercentage !== null ? (
                    <span className="textRight">
                      <b>{downpaymentPercentage}%</b>
                    </span>
                  ) : downpaymentDollar !== null ? (
                    <span className="textRight">
                      <b>{formatCurrency(downpaymentDollar.toString())}</b>
                    </span>
                  ) : (
                    <span className="textRight">
                      <b>Pending</b>
                    </span>
                  )}
                </div>
                <div className="tenPx"></div>
                {preApprovalAmtFormatted === "TBD" ||
                (downpaymentPercentage === null &&
                  downpaymentDollar === null) ? null : (
                  <GeneratePreApprovalButton
                    clientName={clientName}
                    loanOfficerName={loanOfficerName}
                    loanOfficerEmail={loanOfficerEmail}
                    agentPartner={agentPartner}
                    agentEmail={agentEmail}
                    preApprovalAmt={preApprovalAmtFormatted}
                    downpaymentPercentage={downpaymentPercentage}
                    downpaymentDollar={downpaymentDollar}
                    loanProgram={loanProgram}
                    googleTemplateID={googleTemplateID}
                    googleFolderId={googleFolderId}
                    preApprovalNames={preApprovalNames}
                    loanOfficerPhone={loanOfficerPhone}
                    agentPhone={agentPhone}
                    coAgentPhone={coAgentPhone}
                    loanOfficerTextNotifications={loanOfficerTextNotifications}
                    agentTextNotifications={agentTextNotifications}
                    coAgentTextNotifications={coAgentTextNotifications}
                  />
                )}
              </div>
            )}
          </div>
        </div>
        <EditNotesModal />
      </EditNoteContext.Provider>
    </div>
  );
};

export default PreApprovalPanel;
